import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "radio-component d-flex" }
const _hoisted_2 = ["innerHTML"]

import { ref, watch, onMounted } from 'vue'
import { answerItemBodyParser } from "../../../../helpers/question-parser"
import AnswerItem from "../../../../common/AnswerItem"


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionRadio',
  props: {
    list: { default: () => [] },
    value: { default: '' },
    trueBgr: { default: '' },
    falseBgr: { default: '' },
    readonly: { type: Boolean, default: false },
    callBackChange: { type: Function, default: () => {} },
    color: { default: '' }
  },
  setup(__props: any) {

const props = __props

const radios = ref('')

watch(() => props.value, (val, oldVal) => {
  if (val !== oldVal) {
    radios.value = val
  }
})

onMounted(() => {
  if (props.value.length) {
    radios.value = props.value
  }
})

const getStyle = (item: any) => {
  if (props.trueBgr && item.correct) {
    return {
      'background-color': props.trueBgr
    }
  }
  if (props.falseBgr && !item.correct) {
    return {
      'background-color': props.falseBgr
    }
  }
  if (props.color != '') {
    return {
      'background-color': props.color
    }
  }
}

const onChange = (val: any) => {
  props.callBackChange(val)
}

const parserBody = (answerItem: AnswerItem) => {
  return answerItemBodyParser(answerItem.body)
}

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_col, { cols: "12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_radio_group, {
          modelValue: radios.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((radios).value = $event)),
            onChange
          ],
          row: "",
          class: "mt-0 p-0 w-100"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle(getStyle(item)),
                class: "p-2"
              }, [
                (item.name != 'point')
                  ? (_openBlock(), _createBlock(_component_v_radio, {
                      key: 0,
                      value: item.body,
                      color: "success",
                      readonly: __props.readonly
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: parserBody(item)
                        }, null, 8 /* PROPS */, _hoisted_2)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "readonly"]))
                  : _createCommentVNode("v-if", true)
              ], 4 /* STYLE */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})